<div>
  <div *ngIf="hasMenus" class="container-fluid no-padding">
    <app-top-header></app-top-header>    
  </div>
  <div class="wrapper">
    <app-nav-menu *ngIf="hasMenus" (verticalExpand)='getValue($event)'></app-nav-menu>
    <div [ngClass]="{'expanded': collapse , 'main-content' : hasMenus }" style="width: 100vw; min-height:100vh; background-color:white;">
      <ng-content></ng-content>
    </div>
  </div>
</div>
